import React, { useState, useContext, useEffect, use } from 'react';
import { PageContext } from './PageContext';
import { OffcanvasHeader, OffcanvasBody,Row,Col } from 'reactstrap';
import { RollUpGroupList, StatusList } from './FormComponents';
import { ZIndexContext} from '@progress/kendo-react-common';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import {AdJacket} from './AdJacket';
import { ContactList } from './ContactList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCopy, faExclamationTriangle, faLock, faMaximize, faWindowRestore} from '@fortawesome/free-solid-svg-icons';
import {faInfoCircle,faQuestionCircle, faUserAstronaut} from '@fortawesome/free-solid-svg-icons';
import parse from 'html-react-parser';
import { checkAdGroup, findSaleRep, releaseGetNext, updateAdStatus } from '../services/apiService';
import { PackageData, RunDates } from './RunDates';
import { SubelementList } from './SubelementList';
import { HistoryList } from './HistoryList';
import { JobTicket } from './JobTicket';
import { Proof } from './Proof';
import { getProofFiles, approveAd, addWatchList, removeWatchList, makeHotRush, setStat2Field } from '../services/apiService';
import { AdToApprove, FieldValues, rollUpGroup, rollUpMember } from "../services/interfaces";
import {ApproveConfirmDialog, ConfirmDialog} from './ConfirmDialog';
import { SubmissionForm } from './SubmissionForm';
import { SubmissionContextProvider } from './SubmissionFormContext';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { UserContext } from './UserContext';
import { Input, InputChangeEvent} from '@progress/kendo-react-inputs';
import { EmailForm } from './EmailForm';
import {
    Toolbar,
    ToolbarItem,
    ToolbarSeparator,
    Button,
    ButtonGroup,
    DropDownButton,
    DropDownButtonItem,
    SplitButton,
    SplitButtonItem
} from '@progress/kendo-react-buttons';

import { adRecord } from '../services/interfaces';
import { StatusDataItem } from '../services/interfaces';
import { useSearchParams } from 'react-router-dom';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { mailMessage } from '../services/interfaces';
import { sendMailMessage } from '../services/apiService';
import { TrafficPanel } from './TrafficPanel';
import { addUserGroup } from '../services/apiAdminService';
import { Annotorious } from '@annotorious/react';

interface ReadOnlyProofDialogProps {
    onClose: () => void;
}

class ExpandEBoundary extends React.Component<{children: React.ReactNode}>{
    constructor(props: {children: React.ReactNode}){
        super(props);
        this.state={hasError:false}
    }

    static getDerivedStateFromError(error: Error){
        return {hasError:true}
    }
    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.log(error);
        console.log(errorInfo.componentStack);
    }
    render(): React.ReactNode {
        return this.props.children;
    }
}


const ReadOnlyProofDialog: React.FC<ReadOnlyProofDialogProps> = ({ onClose }) => {
    const pageContext = useContext(PageContext);
    const userContext = useContext(UserContext);
    const [readOnlyEmail, setReadOnlyEmail] = useState("");
    const [emailValid, setEmailValid] = useState(false);
    
    const emailValidator = () => {
        const value = readOnlyEmail;
        const emailRegex = new RegExp(/\S+@\S+\.\S+/)
        if (emailRegex.test(value)) {
            setEmailValid(true);
        }
    }
    const SetEmailAddress = (e: InputChangeEvent) => {
        setReadOnlyEmail(e.value);
        //emailValidator();
    }
    const SendReadOnlyProof = () => {
        if(emailValid){
            console.log("Send read only message to:" + readOnlyEmail);
            if (pageContext?.selectedAd && userContext?.user){
                var message:mailMessage={
                    element:pageContext?.selectedAd.element,
                    proofType:pageContext.selectedAd.tmpInt2,
                    emailBody:"",
                    sendTime:new Date(),
                    appUser:userContext.user.username,
                    operation:"997",
                    status:"DEFAULT",
                    recipient:readOnlyEmail,
                    user:userContext.user.username,
                    key:userContext.user.apiKey,
                    includeAds:""
                }
                sendMailMessage(message).then(data=>{
                    console.log(data);
                    onClose();
                });
            }
        }
    }

    useEffect(()=>{
        setReadOnlyEmail("");
    },[])
    useEffect(()=>{
         emailValidator();
    },[readOnlyEmail])


    return (
        <Dialog title={"Send Read-Only Proof"} onClose={onClose} width={"25%"} className={"atol-dlg-info"}>
            <div className="rounded bg-primary text-white p-3 mb-3">
                <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exReadOnlyMessage">{pageContext?.docLinkSet.Links.find(link => link.Placeholder == "ReadOnlyProof")?.Prompt || ""}</span><span className="float-end"><a target="_blank" id="exHelpLink" style={{ color: "white!important" }} className='whitelink' href={pageContext?.docLinkSet.Links.find(link => link.Placeholder == "ReadOnlyProof")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
            </div>
            <Input onChange={SetEmailAddress} value={readOnlyEmail} placeholder='Email Address' valid={emailValid}></Input>
            <DialogActionsBar>
                <Button themeColor={"secondary"} onClick={onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={SendReadOnlyProof}>Send Proof</Button>
            </DialogActionsBar>
        </Dialog>
    )
}



export function Expand(){
    const pageContext = useContext(PageContext);
    const [adStatus, setAdStatus]=useState<StatusDataItem>();
    const [selectedTab, setSelectedTab] = useState<number>(1);
    const toggleExpand=()=>pageContext?.setShowExpand(!pageContext?.showExpand);
    const [expandConfirmTitle, setExpandConfirmTitle] = useState("");
    const [expandConfirmVisible, setExpandConfirmVisible] = useState(false);
    const [expandConfirmMessage, setExpandConfirmMessage] = useState("");
    const [expandConfirmConfirm, setExpandConfirmConfirm] = useState(() => () => {});
    const [expandConfirmCancel, setExpandConfirmCancel] = useState<() => void>(() => {});
    const [approveConfirmVisible, setApproveConfirmVisible]=useState(false);
    const [statChangeConfirmVisible, setStatChangeConfirmVisible]=useState(false);
    const [successMsg,setSuccessMsg]=useState("");
    const [showSuccess, setShowSuccess]=useState(false);
    const [errorMsg,setErrorMsg]=useState("");
    const [showError, setShowError]=useState(false);
    const [submitVisible, setSubmitVisible]=useState(false);
    const [submitTitle, setSubmitTitle]=useState("Submit");
    const [submitType,setSubmitType] =useState("SB");
    const [rushTypeVisible, setRushTypeVisible] = useState(false);
    const [rushOptions, setRushOptions] = useState<any[]>([]);
    const [rushType, setRushType] = useState({text:"Select Rush Type", value:""});
    const [readOnlyVisible,setReadOnlyVisible]=useState(false);
    const [showEmailPrompt, setShowEmailPrompt]=useState(false);
    const audio = new Audio("/assets/ding-36029.mp3");
    const [showEmailForm, setShowEmailForm]=useState(false);
    const [dismissProofPrompt,setDismissProofPrompt]=useState(false);
    
    const [emailPromptMessage,setEmailPromptMessage]=useState("");
    const [emailType,setEmailType]=useState("");
    const [readOnlyEmail, setReadOnlyEmail]=useState(false);
    const [showConfirmUpdate, setShowConfirmUpdate]=useState(false);
    const [ajFields, setAjFields]=useState<FieldValues>({
            Status: pageContext?.selectedAd.status||"",
            Customer: pageContext?.selectedAd.customer||"",
            Account: pageContext?.selectedAd.fileSize2||"",
            Site: pageContext?.selectedAd.file1||"",
            Size: pageContext?.selectedAd.size||"",
            TmpChar2: pageContext?.selectedAd.tmpChar2||"",
            Salesman: pageContext?.selectedAd.salesman||"",
            Deadline: pageContext?.selectedAd.currentDeadline.toString()||"",
            Type: pageContext?.selectedAd.category||"",
            SubStatus: "",
            Section: pageContext?.selectedAd.fileSize1||"",
            Team: "",
            Color: pageContext?.selectedAd.rCopyStatus||"",
            Tagline: pageContext?.selectedAd.comment2||"",
            Comment: pageContext?.selectedAd.comment||"",
            Key: pageContext?.selectedAd.tmpChar3||"",
            Temp3: "",
            ParentAd: pageContext?.selectedAd.groupAdNum||"",
            Queue: pageContext?.selectedAd.queue||"",
            rCopyLines:pageContext?.selectedAd.rCopyLines||"",
            rCopyUO: pageContext?.selectedAd.rCopyUo||""
    });



    const showSetStatusConfirm=()=>{
        setStatChangeConfirmVisible(true);
    }
    const hideSetStatusConfirm=()=>{
        setStatChangeConfirmVisible(false);
    }

    const notifySuccess=()=>{
        setShowSuccess(true);
    }
    const hideNotifySuccess=()=>{
        setShowSuccess(false);
    }

    const notifyError=()=>{
        setShowSuccess(true);
    }
    const hideNotifyError=()=>{
        setShowSuccess(false);
    }

    const viewEmailPrompt=()=>{
        setShowEmailPrompt(true);
    }

    const hideEmailPrompt=()=>{
        setDismissProofPrompt(true);
        setShowEmailPrompt(false);
    }

    const hideSubmit=()=>{
        setSubmitVisible(false);
    }

    const showRushType=()=>{
        setRushTypeVisible(true);
    }

    const hideRushType=()=>{
        setRushTypeVisible(false);
    }

    const viewEmailForm=()=>{
        setShowEmailForm(true);
    }

    const hideEmailForm=()=>{
        hideEmailPrompt();
        setShowEmailForm(false);
    }

    const promptConfirmUpdate=()=>{
        setShowConfirmUpdate(true);
    }

    const hideConfirmUpdate=()=>{
        setShowConfirmUpdate(false);
    }
    
    const ShowReadOnlyProof=()=>{
        setReadOnlyEmail(true);
        viewEmailForm();
        //setReadOnlyVisible(true);
    }

    const HideReadOnlyProof=()=>{
        setReadOnlyVisible(false);
    }

    const showSubmit=()=>{
        if (pageContext?.selectedAd.tmpInt2==0){
            setSubmitType("SB");
            setSubmitTitle("Submit materials for ad " + pageContext?.selectedAd.slug);
        }else{
            setSubmitType("CR");
            setSubmitTitle("Submit corrections for ad " + pageContext?.selectedAd.slug);
        }
        setSubmitVisible(true);
    }

    const showPickup=()=>{
        setSubmitType("PU");
        setSubmitTitle("Pickup " + pageContext?.selectedAd.slug + " To:");
        setSubmitVisible(true);
    }

    const [SearchParams] = useSearchParams();
    const act = SearchParams.get('act');


    function newStatusConfirm(stat:any){
        console.log(stat);
        setAdStatus(stat);
        showSetStatusConfirm();
    }

    function setNewStatus(){
        const stat = adStatus?.status||"";
        if (pageContext && pageContext.selectedAd.element!="" && stat!=""){
            updateAdStatus(pageContext.selectedAd.element, stat);
        }else{
            console.log("Status not set");
        }
        hideSetStatusConfirm();
    };

    const addWatch=()=>{
        const element = pageContext?.selectedAd.element;
        addWatchList(element).then(resp=>{
            if (resp!="Error"){
                setSuccessMsg(element + " has been added to your watch list.")
                notifySuccess();
                setTimeout(function () { hideNotifySuccess() }, 5000);
                pageContext?.setRefreshActiveGrid(true) // Refresh the active grid after removing watch
            }else{
                setErrorMsg("An error occurred." + element + " has not been added to your watch list.")
                notifyError();
                setTimeout(function () { hideNotifyError() }, 5000);
            }
        });
    }

    const removeWatch=()=>{
        const element = pageContext?.selectedAd.element;
        removeWatchList(element).then(resp=>{
            if (resp!="Error"){
                setSuccessMsg(element + " has been removed from your watch list.")
                notifySuccess();
                setTimeout(function () { hideNotifySuccess() }, 5000)
                pageContext?.setRefreshActiveGrid(true) // Refresh the active grid after removing watch
            }else{
                setErrorMsg("An error occurred." + element + " has not been removed from your watch list.")
                notifyError();
                setTimeout(function () { hideNotifyError() }, 5000);
            }
        });
    }

    const openPDF =()=>{
        var d = new Date();
        var tick = d.getTime();
        var pdfPath = pageContext?.proofFiles.pdfURL + "&t=" + tick;
        var newtab = window.open(pdfPath,"_blank");
        if (newtab && pageContext?.selectedAd.element) {
            newtab.document.title = pageContext.selectedAd.element;
        }
    }
    const isHold=()=>{
        if (pageContext){
            const adStatus = pageContext.selectedAd.status;
            const holdStatuses = pageContext.atolStatuses.HoldStatuses;
            if (holdStatuses.indexOf(adStatus)!=-1){
                return true;
            }else{
                return false;
            }        
        }
    }

    
    const handleSelect = (e: TabStripSelectEventArguments) => {
        console.log("Expand Tab Changed");
        const elements = document.getElementsByClassName("a9s-popup");
        for (let i=0;i<elements.length;i++){
            elements[i].remove();
        }
        setSelectedTab(e.selected);
    };

    function copyClipboard(){
        navigator.clipboard.writeText(pageContext?.selectedAd.element||"");
    }
    const showApproveConfirm=()=>{
        setApproveConfirmVisible(true);
    }
    const hideApproveConfirm=()=>{
        setApproveConfirmVisible(false);
    }
    const ConfirmApprove=()=>{        
        console.log("Approve clicked");
        showApproveConfirm();
    }
    const ApproveAd=(rating:{
        accuracy:number,
        creativity:number,
        timliness:number
    })=>{
        hideApproveConfirm();
        console.log("Approve confirmed");
        console.log(rating);
        const adToApprove:AdToApprove={
            element: pageContext?.selectedAd.element || "",
            adType:pageContext?.selectedAd.elementType||"",
            setStatus:"",
            approvalEmail:"",
            account:pageContext?.selectedAd.fileSize2||"",
            salesRep:pageContext?.selectedAd.salesman||"",
            rating: rating.accuracy.toString() + rating.creativity.toString() + rating.timliness.toString()
        }
        console.log(adToApprove);
        approveAd(adToApprove).then(()=>{
            if (pageContext?.selectedAd.element){
                setSuccessMsg(pageContext.selectedAd.element + " has been approved.");
                setShowSuccess(true);
                pageContext?.setRefreshActiveGrid(true);
            }
        });
    }

    const closeExpand=()=>{
        const element = pageContext?.page.fromGetNext||"";
        if (element!=""){
            releaseGetNext(element);
        }
        toggleExpand();
    }
    const userContext = useContext(UserContext);

    async function getRushOptions() {
        const user = userContext?.user;    
        const userDir = "users/" + user?.username;
        const rushOptionsPath = userDir + "/rushOptions.json";    
        await fetch(rushOptionsPath)
            .then((response) => response.json())
            .then((data) => setRushOptions(data));
    }

    const handleRushTypeChange = (e: DropDownListChangeEvent) => {
        console.log(e.value);
        setRushType(e.value);
    }

    const setRush=()=>{
        if (rushType.value==""){
            setErrorMsg("Please select a rush type.");
            notifyError();
            setTimeout(function () { hideNotifyError() }, 5000);
            return;
        }
        makeHotRush(pageContext?.selectedAd.element ?? "", 1, Number(rushType.value)).then(resp=>{
            console.log(resp)
            setRushTypeVisible(false);
            if(resp=="200"){
                setSuccessMsg("Ad set to rush successfully.");
                notifySuccess();
                setTimeout(function () { hideNotifySuccess() }, 5000);
            }
        });
    }

    const setHot=()=>{
        makeHotRush(pageContext?.selectedAd.element ?? "", 0, 0).then(resp=>{
            console.log(resp)
            if(resp=="200"){
                setSuccessMsg("Ad set to hot successfully.");
                notifySuccess();
                setTimeout(function () { hideNotifySuccess() }, 5000);
            }
        });
    }

    const[adGroup,setAdGroup]=useState<rollUpGroup>({  
        groupId:"",
        groupName:"",
        primary:false
    });

    const [showAssignGroup, setShowAssignGroup]= useState(false);

    const setAdRollUpGroup=(group:rollUpGroup)=>{
        group.primary=true
        setAdGroup(group);
    }

    const closeAssignGroup=()=>{
        setShowAssignGroup(false);
    }

    const assignGroup=()=>{
        console.log(pageContext?.selectedAd);
        findSaleRep(pageContext?.selectedAd.salesman).then(data=>{
            if (data){
                const username = data[0].userName;
                var newGroup:rollUpMember={
                    username:username,
                    groupId:adGroup.groupId,
                    primary:true
                }
                addUserGroup(newGroup).then(grpData=>{
                    console.log(grpData);
                    if (grpData=="200"){
                        setShowAssignGroup(false);
                    }
                });

            }
        })
    }

    const AssignGroupDialog=()=>{
        return(
            <Dialog title="Assign Group" className='atol-dlg-info' onClose={closeAssignGroup} width={"25%"}>
                <p>The salesperson for the selected ad has not been assigned to a group. Please select a group for this salesperson before proceeding.</p>
                <RollUpGroupList setValue={setAdRollUpGroup} value={adGroup} valid={adGroup.groupId!==""?true:false}></RollUpGroupList>
                <DialogActionsBar>
                    <Button themeColor={"primary"} onClick={assignGroup}>Assign</Button>
                </DialogActionsBar>
            </Dialog>
        )
    }

    const RushTypeDialog=()=>{
        return(
            <Dialog title={"Rush Type"} onClose={hideRushType} width={"25%"} className={"atol-dlg-info"}>
                <div>
                    <p>Please select the rush type for this ad:</p>
                    <DropDownList 
                        data={rushOptions}
                        textField="text"
                        dataItemKey="value"
                        defaultValue={{text:"Select Rush Type", value:""}}
                        value={rushType}
                        fillMode={"outline"}
                        
                        onChange={handleRushTypeChange}
                    />
                </div>
                <DialogActionsBar>
                    <Button themeColor={"secondary"} onClick={hideRushType}>Cancel</Button>
                    <Button themeColor={"primary"} onClick={setRush}>Set Rush</Button>
                </DialogActionsBar>
            </Dialog>
        );
    }

    const actionButtonClick=(e:any)=>{
        console.log(e);
        const action = e.item.text;
        switch (action){
            case "Creative Change":
                setSelectedTab(3)
                break;
            case "Make Rush":
                showRushType();
                break;
            case "Make Hot":
                setHot();
                break;
            case "Send Read-Only Proof":
                ShowReadOnlyProof();
                break;
        }
    }

    function checkAction(){
        if (act){
            switch (act){
                case "A":
                    ConfirmApprove();
                    break;
                case "C":
                    showSubmit();
                    break;
                case "S":
                    showSubmit();
                    break;
            }
        }
    }

    const [timerID, setTimerID]=useState<ReturnType<typeof setTimeout>>();

    const updateAd=()=>{
        console.log("Update ad");
        console.log(ajFields);
        if (pageContext?.uiFeatures.adJacketEnabled){
            //status field
            if (ajFields.Status !== pageContext?.selectedAd.status){
                setStat2Field(pageContext?.selectedAd.element,"status",ajFields.Status);
            }
            //Customer Field
            if (ajFields.Customer !== pageContext?.selectedAd.customer){
                setStat2Field(pageContext?.selectedAd.element,"customer",ajFields.Customer);
            }
            //Account field
            if (ajFields.Account !== pageContext?.selectedAd.fileSize2){
                setStat2Field(pageContext?.selectedAd.element,"file_size2",ajFields.Account);
            }
            //Size field
             if (ajFields.Size !== pageContext?.selectedAd.size){
                setStat2Field(pageContext?.selectedAd.element,"size",ajFields.Size);
            }
            //Build size tmp_char2 field
             if (ajFields.TmpChar2 !== pageContext?.selectedAd.tmpChar2){
                setStat2Field(pageContext?.selectedAd.element,"tmp_char2",ajFields.TmpChar2);
            }
             //Build color rCOpyStatus field
             if (ajFields.Color !== pageContext?.selectedAd.rCopyStatus){
                setStat2Field(pageContext?.selectedAd.element,"r_copy_status",ajFields.Color);
            }
             //Build temp3 field
             if (ajFields.Temp3 !== pageContext?.selectedAd.temp3){
                setStat2Field(pageContext?.selectedAd.element,"temp_3",ajFields.Temp3);
            }
             //Build parentAd field
             if (ajFields.ParentAd !== pageContext?.selectedAd.groupAdNum){
                setStat2Field(pageContext?.selectedAd.element,"group_ad_num",ajFields.ParentAd);
            }
             //Build comment field
             if (ajFields.Comment !== pageContext?.selectedAd.comment){
                setStat2Field(pageContext?.selectedAd.element,"Comment",ajFields.Comment);
            }
            //Build tagline field
             if (ajFields.Tagline !== pageContext?.selectedAd.comment2){
                setStat2Field(pageContext?.selectedAd.element,"comment2",ajFields.Tagline);
            }
            //key  rCopyLines field
            if (ajFields.rCopyLines !== pageContext?.selectedAd.rCopyLines){
                setStat2Field(pageContext?.selectedAd.element,"r_copy_lines",ajFields.rCopyLines);
            }
             //key  section field
            if (ajFields.Section !== pageContext?.selectedAd.section){
                setStat2Field(pageContext?.selectedAd.element,"section",ajFields.Section);
            }
             //key  section field
            if (ajFields.Key !== pageContext?.selectedAd.tmpChar3){
                setStat2Field(pageContext?.selectedAd.element,"tmp_char3",ajFields.Key);
            }
        }else{
            //Only update the tagline
            console.log(pageContext?.selectedAd.comment2);
            setStat2Field(pageContext?.selectedAd.element,"comment2",pageContext?.selectedAd.comment2);
        }
        confirmUpdateComplete();
        hideConfirmUpdate();
    }

    const confirmUpdateComplete=()=>{
        setSuccessMsg("Update complete");
        notifySuccess();
    }

    const enableChangeStatus=()=>{
        if (pageContext?.atolStatuses.LockSetStatusOn?.split(',').includes(pageContext?.selectedAd.status)){
            //the ad is in a lock status
            if (pageContext.uiFeatures.changeLockStatus.toLocaleLowerCase()=="true"){
                //change locked status is allowed
                return true
            }else{
                //change lock status is not allowed
                return false    
            }          
        }else{
            //ad is not in a locked status
            return true
        }             
    }

    useEffect(()=>{
        console.log(adGroup);
    },[adGroup])

    useEffect(()=>{
        console.log("Selected Tag: " + selectedTab);
        console.log("Dismiss Proof Prompt:" + dismissProofPrompt);
        console.log("Proof Type: " + pageContext?.selectedAd.tmpInt2);
        console.log("Ad Status: " + pageContext?.selectedAd.status);
        console.log("Lock statuses: " + pageContext?.atolStatuses.LockStatuses);
        if (selectedTab==0 && dismissProofPrompt==false){
            if((pageContext?.selectedAd.tmpInt2 ?? 0) > 0){ 
                if (pageContext && pageContext.selectedAd.status == pageContext.atolStatuses.SendToPost){
                    //Ad has a proof and is in a proof status so start the timer
                    
                    setEmailPromptMessage("Are you ready to send a proof?");
                    setEmailType("995");
                    console.log("Start Proof Timer");
                    if (timerID){
                        clearInterval(timerID);
                    }
                    //if (pageContext.timerActive==true){
                        const intervalID = setTimeout(() => {
                        console.log("Proof Prompt");
                        viewEmailPrompt();
                        }, 60000);
                        setTimerID(intervalID);
                    //}   
                }
                else{
                    console.log("Failed Proof status check");
                }
            }
            else{
                console.log("Failed proof exists check");
                console.log(pageContext?.selectedAd.tmpInt2 + " " + pageContext?.selectedAd.status);
            }
        }else{
            if (dismissProofPrompt==false){
                if (!pageContext?.atolStatuses.LockStatuses?.split(",").includes(pageContext?.selectedAd.status)){
                    if (pageContext?.dashStat.Dash1Status.split(",").includes(pageContext.selectedAd.status)){
                        setEmailPromptMessage("Are you ready to send a request for materials?");
                        setEmailType("990");
                        console.log("Start Material Request Timer");
                        if (timerID){
                            clearInterval(timerID);
                        }
                        //if (pageContext.timerActive==true){
                             const intervalId=setTimeout(() => {
                             console.log("Material Submission Prompt");
                             viewEmailPrompt();
                             }, 60000);
                             setTimerID(intervalId);
                        //}        
                    }
                }
            }
        }
    },[selectedTab])

    useEffect(()=>{
        if (showEmailPrompt==true){
           // audio.play();
        }
    },[showEmailPrompt]);

    useEffect(()=>{
        if (pageContext?.timerActive===false){
            console.log ("Stop timers");
            clearInterval(timerID);
        }
    },[pageContext?.timerActive])

    useEffect(()=>{
        console.log(ajFields);
    },[ajFields])

    useEffect(() => {
        console.log(pageContext?.selectedAd);
        console.log(userContext?.user);
        if ((pageContext?.selectedAd.tmpInt2 ?? 0) > 0){
            setSelectedTab(0);
        }
        getProofFiles(pageContext?.selectedAd.element, pageContext?.selectedAd.slug, pageContext?.selectedAd.tmpInt2,"","1",pageContext?.selectedAd.file1).then(data=>{
            console.log(data);
            pageContext?.setProofFiles(data);
        });
        console.log(pageContext?.atolStatuses.LockStatuses);
        checkAction();
        getRushOptions();
        if (userContext?.user.trafficUser==true){
            //if this is a traffic user then check the roll up group for this ad.
            checkAdGroup(pageContext?.selectedAd.element).then(data=>{
                console.log(data);
                if (data[0]=="UNASSIGNED"){
                    setShowAssignGroup(true);
                }
            })
        }
    }, []);

    return(
        <ExpandEBoundary>
        <div>
        <OffcanvasHeader toggle={closeExpand}>
            {pageContext?.selectedAd.element} <a href="#" onClick={copyClipboard}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a> {pageContext?.expandMax?<button type="button" className="btn btn-link p-0 border-0" onClick={() => pageContext?.setExpandMax(false)}><FontAwesomeIcon icon={faWindowRestore}></FontAwesomeIcon></button>:<button type="button" className="btn btn-link p-0 border-0" onClick={() => pageContext?.setExpandMax(true)}><FontAwesomeIcon icon={faMaximize}></FontAwesomeIcon></button> }
        </OffcanvasHeader>
        <OffcanvasBody className='h-100'>
            {approveConfirmVisible && <ApproveConfirmDialog title="Approve This Ad?" message="Are you sure you want to approve this ad?" confirmButtonText="Yes" cancelButtonText="No" onConfirm={ApproveAd} onClose={hideApproveConfirm}></ApproveConfirmDialog>}
            {statChangeConfirmVisible && <ConfirmDialog type="INFO" title="Change Ad Status?" message="Are you sure you want to change the status of this ad?" confirmButtonText="Yes" cancelButtonText="No" onConfirm={setNewStatus} onClose={hideSetStatusConfirm}></ConfirmDialog>}
            {rushTypeVisible && <RushTypeDialog></RushTypeDialog>}
            {showAssignGroup && <AssignGroupDialog></AssignGroupDialog>}
            {showEmailForm && <EmailForm onClose={hideEmailForm} selectedContact={[]} emailType={emailType} helpMe={true} readonly={readOnlyEmail}></EmailForm>}
            {showConfirmUpdate && <ConfirmDialog type="INFO" onClose={hideConfirmUpdate} title='Confirm ' message='Are you sure you want to update this ad?' confirmButtonText='Yes' cancelButtonText='No' onConfirm={updateAd}></ConfirmDialog>}
            <ZIndexContext.Provider value={1060}>
                {showSuccess&& <Notification type={{style:"success", icon:true}} onClose={hideNotifySuccess} closable={true}><span>{successMsg}</span></Notification>}
                {showError&& <Notification type={{style:"error", icon:true}}><span>{errorMsg}</span></Notification>}
                {showEmailPrompt&& <Notification type={{style:"info"}}>
                    <Row>                        
                        <Col xs="9">
                        <FontAwesomeIcon icon={faUserAstronaut}></FontAwesomeIcon>&nbsp;<span><strong>{emailPromptMessage}</strong></span>
                        </Col>
                        <Col xs="3">
                        <Button size={"small"} themeColor={"primary"} onClick={viewEmailForm}>Yes</Button>&nbsp;<Button size={"small"} themeColor={"secondary"} onClick={hideEmailPrompt}>No</Button>
                        </Col>
                    </Row>
                    </Notification>}
                {pageContext?.uiFeatures.changeStatus.toLowerCase()==="true"?
                    pageContext.selectedAd.pub0!=="2"?
                    <StatusList setStatus={newStatusConfirm} 
                        value={[adStatus?.status||""]}
                        type='single'
                        limited={true} 
                        enabled={
                            enableChangeStatus()
                        }
                    ></StatusList>:null
                :null}
                {pageContext?.selectedAd.pub0!=="2"?
                    pageContext?.atolStatuses.LockStatuses?.split(",").includes(pageContext?.selectedAd.status)?
                        <div className="rounded bg-warning  p-3 mb-3">
                            <FontAwesomeIcon icon={faLock}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage">This ad is in a locked status. Changes are not available. Please contact your support representative for assistance.</span>
                        </div>
                    :
                        <div className="rounded bg-primary text-white p-3 mb-3">
                            <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage">{pageContext?.selectedAd.tmpInt2==0||pageContext?.selectedAd.tmpInt2==undefined?parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitCopy")?.Prompt||""):parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="ProofReview")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="exHelpLink" style={{color:"white!important"}} className='whitelink' href={pageContext?.selectedAd.tmpInt2==0||pageContext?.selectedAd.tmpInt2==undefined?pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="SubmitCopy")?.Url:pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="ProofReview")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
                        </div>
                :
                <div className="rounded bg-warning  p-3 mb-3">
                    <FontAwesomeIcon icon={faExclamationTriangle}></FontAwesomeIcon>&nbsp;<span id="exPromptMessage">This ad has been archived. Changes are not available. Please contact your support representative for assistance.</span>
                </div>
                }
                <Toolbar>
                    <Button className="k-toolbar-button" title='Update' onClick={promptConfirmUpdate}>Update</Button>
                    {pageContext?.proofFiles.pdfURL!="" && pageContext?.proofFiles.pdfURL!=null?<Button className="k-toolbar-button" title='PDF' onClick={openPDF}>PDF</Button>:null}
                    {pageContext?.selectedAd.tmpInt2!=0? (pageContext?.atolStatuses.LockStatuses?.split(',').includes(pageContext?.selectedAd.status) ? null : <Button className="k-toolbar-button" title='Approve' onClick={ConfirmApprove}>Approve</Button>):null}
                    {pageContext?.atolStatuses.LockStatuses?.split(",").includes(pageContext?.selectedAd.status)? null : pageContext?.selectedAd.pub0=="2"?null: <Button className="k-toolbar-button" title='Submit Files' onClick={showSubmit}>{isHold() ? "Resolve Hold" : (pageContext?.selectedAd?.tmpInt2 === 0 ? "Submit Files" : "Corrections")}</Button>}
                    <Button className="k-toolbar-button" onClick={showPickup} title='Pickup'>Pickup To</Button>
                    {pageContext?.selectedAd.watching==""? <Button className="k-toolbar-button" title='Add Watch' onClick={addWatch}>Add Watch</Button>:<Button className="k-toolbar-button" title='Remove Watch' onClick={removeWatch}>Remove Watch</Button>}
                    <SplitButton className="k-toolbar-split-button" text="Actions" onItemClick={actionButtonClick}>
                        <SplitButtonItem  text="Creative Change" />
                        {pageContext?.uiFeatures.makeRush==true ?
                        <>
                            {pageContext?.atolStatuses.RushLockStatuses?.split(',').includes(pageContext?.selectedAd.status) ? null : <SplitButtonItem text="Make Rush" />}
                        </>
                        :null}
                        {pageContext?.uiFeatures.makeHot==true ?
                        <>
                            {pageContext?.atolStatuses.RushLockStatuses?.split(',').includes(pageContext?.selectedAd.status) ? null : <SplitButtonItem text="Make Hot" />}
                        </>
                        :null}
                        {pageContext?.uiFeatures.sendReadOnlyProof?
                            <SplitButtonItem text="Send Read-Only Proof"/>
                        :null}
                    </SplitButton>
                </Toolbar>
                <TabStrip selected={selectedTab} onSelect={handleSelect}>
                    <TabStripTab title="Proof" contentClassName='expand-panel'>
                        <Proof></Proof>
                    </TabStripTab>
                    <TabStripTab title="Ad Jacket" contentClassName='expand-panel'>
                        <div className="rounded bg-primary text-white p-3 mb-3">
                            <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="ajPromptMessage">{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="AdJacket")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="ajHelpLink" className='whitelink' style={{color:"white!important"}} href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="AdJacket")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
                        </div>
                        <AdJacket ajFields={ajFields} setAjFields={setAjFields} ></AdJacket>
                    </TabStripTab>
                    <TabStripTab title="Contacts" contentClassName='expand-panel'>
                        <div className="rounded bg-primary text-white p-3 mb-3">
                            <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="ajPromptMessage">{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="Contacts")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="ajHelpLink" className='whitelink' style={{color:"white!important"}} href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="Contacts")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
                        </div>
                        <ContactList></ContactList>
                    </TabStripTab>
                    <TabStripTab title="Size/Run" contentClassName='expand-panel'>
                        <div className="rounded bg-primary text-white p-3 mb-3">
                            <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="ajPromptMessage">{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="RunDates")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="ajHelpLink" className='whitelink' style={{color:"white!important"}} href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="RunDates")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
                        </div>
                        <RunDates></RunDates>
                        <PackageData></PackageData>
                    </TabStripTab>
                    <TabStripTab title="Components" contentClassName='expand-panel'>
                        <div className="rounded bg-primary text-white p-3 mb-3">
                            <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="ajPromptMessage">{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="Components")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="ajHelpLink" className='whitelink' style={{color:"white!important"}} href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="Components")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
                        </div>
                        <div className='expand-panel-content'>
                            <SubelementList></SubelementList>
                        </div>
                    </TabStripTab>
                    <TabStripTab title="Tickets" contentClassName='expand-panel'>
                        <div className='expand-panel-content'>
                            <JobTicket></JobTicket>
                        </div>
                    </TabStripTab>
                    <TabStripTab title="History" contentClassName='expand-panel'>
                        <div className="rounded bg-primary text-white p-3 mb-3">
                            <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="ajPromptMessage">{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="History")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="ajHelpLink" className='whitelink' style={{color:"white!important"}} href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="History")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
                        </div>
                        <div className='expand-panel-content'>
                            <HistoryList></HistoryList>
                        </div>
                    </TabStripTab>
                    {userContext?.user.trafficUser===true?
                        //This is a traffic user
                        <TabStripTab title="Traffic" contentClassName='expand-panel'>
                            <div className="rounded bg-primary text-white p-3 mb-3">
                                <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon>&nbsp;<span id="ajPromptMessage">{parse(pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="AdTraffic")?.Prompt||"")}</span><span className="float-end"><a target="_blank" id="ajHelpLink" className='whitelink' style={{color:"white!important"}} href={pageContext?.docLinkSet.Links.find(link=>link.Placeholder=="AdTraffic")?.Url}><FontAwesomeIcon icon={faQuestionCircle}></FontAwesomeIcon>&nbsp;Learn More</a></span>
                            </div>
                            <TrafficPanel></TrafficPanel>
                        </TabStripTab>
                    :null}
                </TabStrip>
            </ZIndexContext.Provider>
            {submitVisible &&
                <SubmissionContextProvider><SubmissionForm title={submitTitle} type={submitType} onClose={hideSubmit}></SubmissionForm></SubmissionContextProvider>
            }
            {readOnlyVisible && <ReadOnlyProofDialog onClose={HideReadOnlyProof}/>}
        </OffcanvasBody>
        </div>
        </ExpandEBoundary>
    )
}
